module.exports = __webpack_public_path__ + "static/media/left-arrow.4da35bbb.svg";